import React, { useEffect, useRef, useContext, useState } from "react";
import { Button, Table, Form, Input, InputNumber, Select, Upload, message } from "antd";
import { useModel } from "../../../models";
import StockSelectionModal from "./StockSelectionModal";
import { DICT_KEY, getDictNameByCode, ENV } from "../../../utils/constants";
import PurchasePoService from "./PurchasePoService";
import { v4 as uuidV4 } from "uuid"
import { formatNum } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    documentMaterialList,
    ...restProps
}) => {
    const [{ warehouseDict, positionDict },] = useModel("cmDict");

    const [editing, setEditing] = useState(false);
    const [newPositionDict, setNewPositionDict] = useState([]);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        // console.log(record.warehouseId,positionDict)
        if (editing) {
            inputRef.current.focus();
            let goodsList = positionDict
                .filter(el => el.warehouseId === record.warehouseId)
                .map(el => ({
                    key: el.key,
                    label: el.label,
                    value: el.value
                }))
            setNewPositionDict(goodsList)
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async e => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    const onKeyDown = async event => {
        if (event.keyCode === 40) {
            let findIndex = documentMaterialList.findIndex(item => item.id == record.id)
            if (findIndex === documentMaterialList.length - 1) {
                return false
            }
            let node = event.target
            let trParentNode = node.closest("tr")
            trParentNode.nextSibling.children[4].children[0].click()
        }
        if (event.keyCode === 38) {
            let findIndex = documentMaterialList.findIndex(item => item.id == record.id)
            if (findIndex === 0) {
                return false
            }
            let node = event.target
            let trParentNode = node.closest("tr")
            trParentNode.previousSibling.children[4].children[0].click()
        }
        // console.log(event.keyCode)
    }
    const onFocus = () => {
        inputRef.current.select()
    }
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <>
                {
                    (() => {
                        if (dataIndex === "purchaseNum") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                    { type: 'number', message: `当前不是一个有效数字`, transform: (value) => { Number(value) } }
                                ]}
                            >
                                <Input
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    onFocus={onFocus}
                                    onKeyDown={onKeyDown}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "purchasePrice") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "discount") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    { required: true, message: `不能为空.`, },
                                    { pattern: /^(([0-9]\d?)|100)$/g, message: '折扣必须是大于等于0且小于等于100的整数' },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                />
                            </Form.Item>
                        } else if (dataIndex === "giftsNum") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                ]}
                            >
                                <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        } else if (dataIndex === "warehouseId") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                ]}
                            >
                                <Select
                                    ref={inputRef}
                                    showSearch
                                    allowClear={true}
                                    placeholder=""
                                    onBlur={save}
                                    filterOption={(input, option) => (option && option.label && option.label.indexOf(input)) >= 0}
                                    options={warehouseDict.map(el => ({
                                        key: el.key,
                                        value: el.value,
                                        label: el.label ? el.label : '空',
                                    }))}
                                />
                            </Form.Item>
                        } else if (dataIndex === "shelfId") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                ]}
                            >
                                <Select
                                    ref={inputRef}
                                    showSearch
                                    allowClear={true}
                                    placeholder=""
                                    onBlur={save}
                                    filterOption={(input, option) => (option && option.label && option.label.indexOf(input)) >= 0}
                                    options={newPositionDict.map(el => ({
                                        key: el.key,
                                        value: el.value,
                                        label: el.label,
                                    }))}
                                />
                            </Form.Item>
                        } else if (dataIndex === "purchaseDesc") {
                            return <Form.Item
                                style={{
                                    margin: 0,
                                }}
                                name={dataIndex}
                                rules={[
                                    {
                                        required: true,
                                        message: `不能为空.`,
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        }
                    }
                    )()
                }
            </>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

export default function ({ getForm }) {
    const [
        {
            documentMaterialList, selectedDocumentMaterialRowKeys,
            detailStatistics, selectedDocument
        },
        {
            setDocumentMaterialList, downloadDetailTpl,
            setSelectedDocumentMaterialRowKeys, setAddMaterialModelVisible,
            removeDocumentMaterial, setDetailStatistics
        }
    ] = useModel("purchasePo");
    const { orderStatus = "025001" } = selectedDocument;
    //财务确认
    const editable01 = (
        orderStatus === "025001"
        || orderStatus === "025002"
        || orderStatus === "025003"
    );
    //库房确认
    const editable02 = (
        orderStatus === "025001"
        || orderStatus === "025002"
    );
    useEffect(() => {
        let poTotalNum = 0, poPayableAmount = 0.00, poTotalAmount = 0.00;
        documentMaterialList.forEach(el => {
            // debugger
            const { purchaseNum, purchasePrice, purchaseAmount } = el;
            poTotalNum = poTotalNum + (purchaseNum ? parseInt(purchaseNum) : 0);
            const itemTotal = (purchaseAmount ? parseFloat(purchaseAmount) : 0.00);
            poPayableAmount = poPayableAmount.add(itemTotal);
            poTotalAmount = poTotalAmount + (purchaseNum * purchasePrice);
        })
        setDetailStatistics({
            poTotalNum,
            poPayableAmount: poPayableAmount.toFixed(2),
            // poPayableAmount:poPayableAmount,
            poTotalAmount: poTotalAmount.toFixed(2),
        })
    }, [documentMaterialList])

    const handleSave = row => {
        setDocumentMaterialList(
            documentMaterialList.map(el => {
                if (el.key === row.key) {
                    let tmp = { ...el, ...row };
                    const { purchaseNum, giftsNum, purchasePrice, discount, warehouseId, shelfId } = tmp
                    tmp.purchaseAmount = ((purchaseNum - giftsNum) * purchasePrice * discount / 100).toFixed(2);
                    tmp.warehouseName = getDictNameByCode(DICT_KEY.CM_DICT.WAREHOUSE, warehouseId);
                    tmp.shelfCode = getDictNameByCode(DICT_KEY.CM_DICT.POSITION, shelfId);
                    return tmp;
                } else {
                    return el;
                }
            })
        )
    }

    const TableHeader = () => {
        const onAdd = () => {
            getForm().validateFields().then(data => {
                setAddMaterialModelVisible(true);
            }).catch(ex => {
                message.error("请输入主表单信息!")
            });
        }
        const onDelete = () => {
            if (!!selectedDocumentMaterialRowKeys) {
                removeDocumentMaterial(selectedDocumentMaterialRowKeys);
            }
        }


        const onDownloadTpl = () => {
            downloadDetailTpl({ showMsg: true, data: {} })
        }

        const onUploadSuccess = (retData) => {
            const mappedList = retData.map(el => ({
                ...el,
                key: uuidV4(),
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
            }));
            setDocumentMaterialList([...documentMaterialList, ...mappedList]);
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div className="detail-list-statistic color-primary">
                    <span className="margin-left-8">采购总数量：{detailStatistics.poTotalNum}</span>
                    <span className="margin-left-16">折后总计：{formatNum(detailStatistics.poPayableAmount)}</span>
                </div>
                <div
                    style={{ width: "460px", textAlign: "right" }}
                    hidden={
                        selectedDocument.orderStatus === "025005"//禁用
                        || selectedDocument.orderStatus === "025004"//结算
                    }
                >
                    <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}>
                        <Button
                            type="primary"
                            onClick={onAdd}
                        >
                            新增商品
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}>
                        <Button className="margin-left-8"
                            onClick={onDelete}
                            disabled={(!!!selectedDocumentMaterialRowKeys.length > 0)}
                        >
                            删除商品
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_IM}>
                        <Upload {...PurchasePoService.getImportDetailCfg({ onUploadSuccess })}>
                            <Button className="margin-left-8">导入</Button>
                        </Upload>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}>
                        <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>
                    </YhAuth>

                </div>
            </div>
        )
    }
    const columns = [
        {
            title: '序号',
            width: 50,
            render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
            width: 120,
            align: 'left',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
            width: 180,
            ellipsis: true,
        },
        /*{
            title: '图号',
            dataIndex: 'replaceNum',
            width: 120,
        },*/
        {
            title: '采购数量*',
            dataIndex: 'purchaseNum',
            width: 100,
            editable: editable02,
        },
        {
            title: '采购单价*',
            dataIndex: 'purchasePrice',
            width: 140,
            editable: editable01,
            // render: text => formatNum(text)
        },
        {
            title: '折扣*',
            dataIndex: 'discount',
            width: 80,
            editable: editable01,
            render: text => text + "%",
        },
        {
            title: '赠品数量*',
            dataIndex: 'giftsNum',
            width: 80,
            editable: editable01,
        },
        {
            title: '总计',
            width: 140,
            dataIndex: 'purchaseAmount',
            // render: (text, record) => (record.purchasePrice * record.purchaseNum * record.discount / 100).toFixed(2),
        },

        /*{
            title: '单位',
            dataIndex: 'materialUnit',
            width: 80,
            render: (text, record) => record.materialUnitName
        },*/
        {
            title: '仓库',
            dataIndex: 'warehouseId',
            width: 160,
            ellipsis: true,
            // editable: editable02,
            render: (text, record) => record.warehouseName ? record.warehouseName : '空',
        },
        {
            title: '货位*',
            dataIndex: 'shelfId',
            width: 160,
            editable: editable02,
            render: (text, record) => record.shelfCode ? record.shelfCode : '空',
        },
        {
            title: '备注*',
            dataIndex: 'purchaseDesc',
            width: 200,
            editable: true,
            render: (text, record) => record.purchaseDesc ? record.purchaseDesc : '空',
        },
    ];
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const mapColumns = handleSave => (columns.map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
                documentMaterialList
            }),
        };
    }));
    return (
        <>
            <TableHeader />
            <Table
                components={components}
                columns={mapColumns(handleSave)}
                dataSource={documentMaterialList}
                bordered
                pagination={false}
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys, selectedRows) => {
                        //选中最后一次点击的记录
                        setSelectedDocumentMaterialRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentMaterialRowKeys
                }}
                scroll={{ x: 'max-content', y: 420 }}
            />

            <StockSelectionModal />
        </>
    )
}